module.exports = __webpack_public_path__ + "static/img/pic_bg.80dc7dec.png";